import { SessionSaleTarget } from './types'

interface ProgramPriorityEntry {
  key: string
  label: string
  match: (target: SessionSaleTarget) => boolean
}

// Product wants programs listed FSP -> Department Chair Success -> Post-Tenure
// Pathfinders. Only FSP has its own session_sale type; DCSP and PTPP are both
// `generic`, with nothing but the slug to tell them apart. Matching is
// deliberately loose so a slug rename degrades to date ordering (see
// programRank) rather than dropping a program off the page.
export const PROGRAM_PRIORITY: ProgramPriorityEntry[] = [{
  key: 'fsp',
  label: 'Faculty Success Program',
  match: target => target.type === 'fsp'
}, {
  key: 'dcsp',
  label: 'Department Chair Success Program',
  match: target =>
    target.type === 'generic' && /department[-_ ]?chair/i.test(target.slug || '')
}, {
  key: 'ptpp',
  label: 'Post-Tenure Pathfinders Program',
  match: target =>
    target.type === 'generic' &&
    /(post[-_ ]?tenure|pathfinder)/i.test(target.slug || '')
}]

// Anything unrecognised ranks last and falls back to date ordering.
export const UNRANKED = PROGRAM_PRIORITY.length

export const programRank = (target: SessionSaleTarget): number => {
  if (!target) return UNRANKED
  const index = PROGRAM_PRIORITY.findIndex(entry => entry.match(target))
  return index === -1 ? UNRANKED : index
}
